/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { hideModal, assignParticipantDocument } from '../../actions/actions';
import AddDocumentComponent from './add.new.participant.document.component';

export const mapStateToProps = (store, ownProps) => {
  return {
    participant: store.subject.participantJourney,
    availableDocuments: store.subject.availableDocuments,
    availableDocumentsError: store.subject.availableDocumentsError,
    isFetchingAvailableDocuments: store.subject.isFetchingAvailableDocuments,
    userId: store.login.user.userId,
    studyConfiguration: store.subject.participantStudy.studyConfiguration,
    consenting: store.subject.consenting,
    errorFetchConsenting: store.subject.errorFetchConsenting,
    isFetchingConsenting: store.subject.isFetchingConsenting
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    close: () => {
      dispatch(hideModal());
    },
    add: (participantJourneyGid, consentId, operation, payload) => {
      return new Promise((resolve, reject) => {
        dispatch(assignParticipantDocument(participantJourneyGid, consentId, operation, payload))
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  };
};

const AddDocumentContainer = connect(mapStateToProps, mapDispatchToProps)(AddDocumentComponent);

export default AddDocumentContainer;
